import * as React from 'react';
import * as style from '../../assets/styles/Layout/NavLinks';
import { NavLink } from 'react-router-dom';
import ICONS from '../../assets/Icons';
import { CONSTANTS } from '../../assets/UIConstants';
import { RouteComponentProps } from 'react-router-dom';

interface Props extends RouteComponentProps<{}> {
}

interface NavRoute {
    route: string;
    name: string;
    icon: React.ComponentClass<{ color?: string, size?: number }>;
}

const navLinks: NavRoute[] = [
    {
        route: '/dashboard',
        name: 'DASHBOARD',
        icon: ICONS.DASHBOARD
    },
    {
        route: '/history',
        name: 'HISTORY',
        icon: ICONS.DASHBOARD
    },
    {
        route: '/contact',
        name: 'CONTACT US',
        icon: ICONS.CONTACT_US
    },
];

export class NavLinks extends React.Component<Props, {}> {

    currentColor: string = CONSTANTS.COLORS.BORDER_GREY;

    render() {
        return (
            <div style={style.navLinksContainer} className={'leftNavBar'}>
                {navLinks.map((nav, index) => {
                    if (this.props.location.pathname.includes(nav.route)) {
                        this.currentColor = CONSTANTS.COLORS.THEME_BLUE;
                    } else {
                        this.currentColor = CONSTANTS.COLORS.BORDER_GREY;
                    }
                    return <NavLink
                        key={index}
                        activeStyle={style.activeNavStyle}
                        style={style.normalStyle}
                        to={nav.route}
                    >
                        <div style={style.iconContainer}>
                            <nav.icon color={this.currentColor} size={20}/>
                        </div>
                        <p>{nav.name}</p>
                    </NavLink>;
                })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/NavLinks.tsx